// extracted by mini-css-extract-plugin
module.exports = {"btn":"UserSettings_btn__PErCy","buttonGroup":"UserSettings_buttonGroup__1QUw9","userSettings":"UserSettings_userSettings__2ZDFu","spinner":"UserSettings_spinner__kWKp_"};